import { action } from 'mobx'
import { validationContext } from 'validx'
import { validateObject } from '@/utils/validx-util'
import { BankAccountEditorViewModel } from './BankAccountEditorViewModel'
import type { DirectDepositTaxRefundDeliveryMethod } from './TaxRefundDeliveryMethod'

/**
 * View model for editing a direct deposit delivery method.
 */
export class DirectDepositDeliveryMethodEditorViewModel {
  readonly bankAccountVm = new BankAccountEditorViewModel()

  readonly validation = validationContext(this, {
    bankAccountVm: [validateObject()],
  })

  /**
   * Resets the state of the view model to that of the given method, or
   * defaults if none is specified.
   */
  @action.bound
  reset(method?: DirectDepositTaxRefundDeliveryMethod) {
    this.bankAccountVm.reset(method?.bankAccount)
    this.validation.reset()
  }

  /**
   * Maps the state of the VM to {@link DirectDepositTaxRefundDeliveryMethod}.
   */
  toDeliveryMethod(): DirectDepositTaxRefundDeliveryMethod {
    return {
      type: 'DirectDeposit',
      bankAccount: this.bankAccountVm.toBankAccountDetails(),
    }
  }
}
